import React from 'react';

export interface ArticlePageBookmarkProps {
    id: string;
}

export const ArticlePageBookmark: React.FC<ArticlePageBookmarkProps> = ({id}) => {
    return <div id={id}/>;
};
